import { createEnv } from '@pickleballinc/lib/env';

import { publicEnvSchema, serverEnvSchema, systemEnvSchema } from '@/lib/env-schema';

export const systemEnv = createEnv(systemEnvSchema, {
	DOCKER_BUILD: process.env.DOCKER_BUILD,
	DEBUG_ENV_VAR: process.env.DEBUG_ENV_VAR,
	BUILD_ID: process.env.BUILD_ID,
	NODE_ENV: process.env.NODE_ENV,
	NEXT_RUNTIME: process.env.NEXT_RUNTIME
});

export const publicEnv = createEnv(publicEnvSchema, {
	NEXT_PUBLIC_APP_ENV: process.env.NEXT_PUBLIC_APP_ENV,
	NEXT_PUBLIC_IMAGE_CDN_URL: process.env.NEXT_PUBLIC_IMAGE_CDN_URL,
	NEXT_PUBLIC_HOME_ROOT_URL: process.env.NEXT_PUBLIC_HOME_ROOT_URL,
	NEXT_PUBLIC_PT_URL: process.env.NEXT_PUBLIC_PT_URL,
	NEXT_PUBLIC_PL_URL: process.env.NEXT_PUBLIC_PL_URL,
	NEXT_PUBLIC_PC_URL: process.env.NEXT_PUBLIC_PC_URL,
	NEXT_PUBLIC_PTL_URL: process.env.NEXT_PUBLIC_PTL_URL,
	NEXT_PUBLIC_APR_URL: process.env.NEXT_PUBLIC_APR_URL,
	NEXT_PUBLIC_SSO_URL: process.env.NEXT_PUBLIC_SSO_URL,
	NEXT_PUBLIC_PBRACKETS_URL: process.env.NEXT_PUBLIC_PBRACKETS_URL,
	NEXT_PUBLIC_BRACKETS_URL: process.env.NEXT_PUBLIC_BRACKETS_URL,
	NEXT_PUBLIC_CONTACT_FORM_URL: process.env.NEXT_PUBLIC_CONTACT_FORM_URL,
	NEXT_PUBLIC_MANAGE_URL: process.env.NEXT_PUBLIC_MANAGE_URL,
	NEXT_PUBLIC_SENTRY_DSN: process.env.NEXT_PUBLIC_SENTRY_DSN,
	NEXT_PUBLIC_RTE_ENABLED: process.env.NEXT_PUBLIC_RTE_ENABLED
});

export const serverEnv = createEnv(serverEnvSchema, {
	API_URL: process.env.API_URL,
	API_URL_V2: process.env.API_URL_V2,
	API_KEY: process.env.API_KEY,
	SENTRY_DEBUG: process.env.SENTRY_DEBUG,
	SENTRY_SAMPLE_RATE: process.env.SENTRY_SAMPLE_RATE,
	SENTRY_TRACES_SAMPLE_RATE: process.env.SENTRY_TRACES_SAMPLE_RATE
});
